import classNames from "classnames";
const Wrapper = ({ children, className = '', ...rest }) => (
  <div className={classNames("wrapper mt-90px pr-4 pl-4", className)} {...rest}>
    {children}
  </div>
)

export default Wrapper;
